<div class="queue-json-builder-wrapper">
    <div class="group">
        <div class="empty-message">
            <small *ngIf="areConditionsEmpty()">Add a condition or a group of conditions.</small>
        </div>

        <!-- ROOT RULES -->
        <div
            class="rule"
            *ngFor="let r of rulesArray(form).controls; let i = index"
            [formGroup]="r"
        >
            <!-- FIELD -->
            <p-dropdown
                class="cv-queues-dropdown"
                formControlName="field"
                [options]="fieldOptions"
                optionLabel="label"
                [autoDisplayFirst]="false"
                placeholder="Select a field"
                optionValue="value"
                appendTo="body"
                (onChange)="onFieldOrOperatorChanged(r)"
            >
            </p-dropdown>

            <!-- OPERATOR -->
            <p-dropdown
                class="cv-queues-dropdown operator"
                formControlName="operator"
                [options]="operatorOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                (onChange)="onFieldOrOperatorChanged(r)"
            >
            </p-dropdown>

            <!-- VALUE -->
            <ng-container *ngIf="shouldUseDropdown(r); else textRoot">
                <p-dropdown
                    class="cv-queues-dropdown value"
                    formControlName="value"
                    [options]="getFieldOptionStrings(r.get('field')!.value)"
                    [filter]="true"
                    [showClear]="true"
                    appendTo="body"
                    placeholder="Select value"
                >
                </p-dropdown>
            </ng-container>

            <ng-template #textRoot>
                <input
                    pInputText
                    class="value cv-queues-input-text"
                    type="text"
                    formControlName="value" 
                    placeholder="Enter value"  
                />
            </ng-template>

            <button class="btn btn-danger" (click)="removeRule(form, i)">✕</button>
        </div>

        <!-- CHILD GROUPS -->
        <div
            class="child"
            *ngFor="let g of groupsArray(form).controls; let gi = index"
            [formGroup]="g"
        >
            <div class="group-head">
                <div class="group-head__left">
                    <span class="badge">{{ g.get('op')!.value | uppercase }}</span>

                    <!-- GROUP OPERATOR -->
                    <p-dropdown
                        class="cv-queues-dropdown"
                        formControlName="op"
                        [options]="logicOpOptions"
                        optionLabel="label"
                        optionValue="value"
                        [showClear]="false"
                        appendTo="body"
                    >
                    </p-dropdown>
                </div>
                <div class="group-head__right">
                    <button
                        pButton
                        class="cv-queues-button p-button-danger"
                        (click)="removeGroup(form, gi)"
                        label="Remove group"
                    >
                    </button>
                </div>
            </div>

            <!-- GROUP RULES -->
            <div
                class="rule"
                *ngFor="let r of rulesArray(g).controls; let i = index"
                [formGroup]="r"
            >
                <!-- FIELD -->
                <p-dropdown
                    class="cv-queues-dropdown"
                    formControlName="field"
                    [options]="fieldOptions"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    placeholder="Select a field"
                    (onChange)="onFieldOrOperatorChanged(r)"
                >
                </p-dropdown>

                <!-- OPERATOR -->
                <p-dropdown
                    class="cv-queues-dropdown operator"
                    formControlName="operator"
                    [options]="operatorOptions"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                    (onChange)="onFieldOrOperatorChanged(r)"
                >
                </p-dropdown>

                <!-- VALUE -->
                <ng-container *ngIf="shouldUseDropdown(r); else textChild">
                    <p-dropdown
                        class="cv-queues-dropdown value"
                        formControlName="value"
                        [options]="getFieldOptionStrings(r.get('field')!.value)"
                        [filter]="true"
                        [showClear]="true"
                        appendTo="body"
                        placeholder="Select value"
                    >
                    </p-dropdown>
                </ng-container>

                <ng-template #textChild>
                    <input
                        pInputText
                        class="value cv-queues-input-text"
                        type="text"
                        formControlName="value"
                        placeholder="Enter value"
                    />
                </ng-template>

                <button class="btn btn-danger" (click)="removeRule(g, i)">✕</button>
            </div>

            <div class="actions">
                <button
                    pButton
                    icon="fa fa-plus"
                    class="cv-queues-button p-button-secondary"
                    label="Add Condition to Group"
                    (click)="addRule(g)"
                ></button>
            </div>
        </div>
    </div>

    <!-- FOOTER ACTIONS -->
    <div class="actions">
        <div class="spacer"></div>
        <button
            pButton
            icon="fa fa-plus"
            class="cv-queues-button p-button-secondary"
            label="Add Condition"
            (click)="addRule(form)"
        ></button>
        <button
            pButton
            icon="fa fa-plus"
            class="cv-queues-button p-button-secondary"
            label="Add Group"
            (click)="addGroup(form)"
        ></button>
        <button
            pButton
            icon="fa fa-trash"
            class="cv-queues-button p-button-secondary p-button-outlined"
            label="Clear All"
            (click)="clearAll()"
        ></button>
    </div>
</div>
